<template>
    <b-container fluid class="home">
        <div v-if="completed">
            <h2>Richiesta completata</h2>
            <p>La tua richiesta è stata completata.</p>
            <p>Verrai contattato per eventuali chiarimenti</p>
        </div>
        <b-form v-else @submit="onSubmit" @reset="onReset">
            <b-row>
                <b-col>
                    <b-form-group label="Nome"
                                  label-for="nome"
                                  description="">

                        <b-form-input id="nome"
                                      v-model="form.nome"
                                      type="text"
                                      placeholder="il tuo nome"
                                      required></b-form-input>
                    </b-form-group>
                </b-col>
                <b-col>
                    <b-form-group label="Cognome"
                                  label-for="cognome"
                                  description="">
                        <b-form-input id="cognome"
                                      v-model="form.cognome"
                                      type="text"
                                      placeholder="il tuo cognome"
                                      required></b-form-input>
                    </b-form-group>
                </b-col>
            </b-row>

            <b-form-group label="Email"
                          label-for="email"
                          description="Email usata per effettuare l'ordine">

                <b-form-input id="email"
                              v-model="form.email"
                              type="email"
                              placeholder="Inserire email"
                              required></b-form-input>
            </b-form-group>

            <b-form-group label="Manubrio"
                          label-for="manubrio"
                          description="Indica su quale manubrio si vuole che venga applicata la serigrafia ( nel caso di acquisti multipli )">

                <b-form-input id="manubrio"
                              v-model="form.manubrio"
                              type="text"
                              placeholder="Su quale manubrio vuoi la serigrafia?"></b-form-input>
            </b-form-group>

            <div class="my-3 canvas-container" style="margin-left: auto; margin-right: auto">
                <h4>Anteprima ( a scopo esemplificativo )</h4>
                <canvas id="canvas" width="1450" height="359"></canvas>
            </div>

            <b-row class="justify-content-md-center">
                <b-col v-for="(cnf, id) in serigrafie" v-bind:key="id" cols="6">
                    <b-row>
                        <b-col>
                            <h3>{{ cnf.nomePosizione }}</h3>
                        </b-col>
                        <b-col>
                            <div v-if="cnf.modalita === 'testo'">
                                <b-button variant="primary" @click="applicaSerigrafia(id)">Applica</b-button>
                            </div>
                            <div v-else>
                                <b-button variant="primary" @click="applicaSerigrafiaLogo(id)">Applica</b-button>
                            </div>
                        </b-col>
                    </b-row>

                    <b-form-group label="Modalita:"
                                  label-for="modalita"
                                  description="Scegli se vuoi applicare un logo oppure una scritta">

                        <b-form-select v-model="cnf.modalita" class="mb-3">
                            <b-form-select-option value="testo">Testo</b-form-select-option>
                            <b-form-select-option value="immagine">Logo</b-form-select-option>
                        </b-form-select>

                    </b-form-group>

                    <!-- modalità: logo -->
                    <div v-if="cnf.modalita === 'testo'">

                        <!-- input: font -->
                        <b-form-group label="Font:"
                                      :label-for="'font-' + cnf.shortName"
                                      :description="`Font da usare per il testo della serigrafia  a ${cnf.shortName}`">
                            <v-select :id="'font-' + cnf.shortName"
                                      placeholder="Font per la scritta"
                                      @input="caricaFont" v-model="cnf.fontFamily"
                                      :options="fonts" label="family" :taggable="false">
                            </v-select>
                        </b-form-group>

                        <!-- input: stile -->
                        <b-form-group label="Stile della scritta:"
                                      :label-for="'stile-' + cnf.shortName"
                                      description="Scegli lo stile della scritta">

                            <b-form-select :id="'stile-' + cnf.shortName"
                                           v-model="cnf.stile"
                                           class="mb-3"
                            >
                                <b-form-select-option value="pieno">Testo pieno</b-form-select-option>
                                <b-form-select-option value="contorno">Solo contorno</b-form-select-option>
                            </b-form-select>

                        </b-form-group>

                        <!-- input: testo -->
                        <b-form-group label="Testo:"
                                      :label-for="'text-' + cnf.shortName"
                                      :description="`Testo da applicare sulla serigrafia a ${cnf.shortName}`">
                            <b-form-input :id="'text-' + cnf.shortName"
                                          v-bind:style="{ fontFamily: cnf.fontFamily.family }"
                                          v-model="cnf.testo"
                                          placeholder="Testo della serigrafia ...">
                            </b-form-input>
                        </b-form-group>

                        <b-row align-h="center">
                            <b-col v-if="cnf.preview" cols="6" class="img-preview">
                                <p style="color:white">Anteprima serigrafia:</p>
                                <b-img v-bind:src="cnf.preview" fluid alt="Anteprima logo"></b-img>
                            </b-col>
                        </b-row>

                    </div>
                    <!-- modalità: logo -->
                    <div v-else>
                        <b-form-file v-model="cnf.logoFile"
                                     accept="image/*"
                                     :state="Boolean(cnf.logoFile)"
                                     placeholder="Scegli o trascina un file qui..."
                                     drop-placeholder="Rilascia il file qui..."></b-form-file>
                        <div class="mt-3">File selezionato: {{ cnf.logoFile ? cnf.logoFile.name : '' }}</div>

                        <b-row align-h="center">
                            <b-col cols="6" v-if="cnf.preview" class="img-preview">
                                <p style="color:white">Logo caricato:</p>
                                <b-img v-bind:src="cnf.preview" fluid alt="Anteprima logo"></b-img>
                            </b-col>
                        </b-row>
                    </div>
                </b-col>
            </b-row>
            <b-row>
                <b-col cols="12" class="py-5">
                    <b-spinner class="mx-5 float-right" v-if="loading" variant="primary"
                               label="Invio in corso ..."></b-spinner>
                    <div v-else>
                        <vue-hcaptcha sitekey="4ec1ef44-8679-4db9-b752-8be197ad43d4"
                                      ref="submitHcaptcha"
                                      size="invisible"
                                      theme="light"
                                      @verify="hcaptchaOnVerify"
                                      @expired="hcaptchaOnExpire"
                                      @challengeExpired="hcaptchaOnExpire"
                                      @error="hcaptchaOnError"
                                      tabindex="0">
                        </vue-hcaptcha>
                        <b-button type="submit" variant="primary" class="float-right">Invia richiesta</b-button>
                    </div>

                </b-col>
            </b-row>
        </b-form>

    </b-container>
</template>
<script>
import {fabric} from "fabric"
import "webfontloader"
import VueHcaptcha from '@hcaptcha/vue-hcaptcha';

const creativeMode = false
const imgWidth = 2250
const pageWdth = window.innerWidth
const scale = pageWdth / imgWidth * 0.8

//const defaultFontFamily = 'Lato'
const defaultFontFamily = 'Aclonica'

export default {
    name: 'Home',
    components: {VueHcaptcha},
    data: () => ({
        fonts: [],
        canvas: null,
        form: {
            manubrio: "",
            email: "",
            nome: "",
            cognome: "",
        },
        serigrafie: [
            {
                nomePosizione: 'serigrafia lato sinistro',
                shortName: 'sinistra',
                coordinate: {
                    left: 122.20689641719332,
                    top: 18.454277963641943,
                    angle: 35
                },
                testo: 'SX',
                fontFamily: 'Train One',
                canvasEl: null,
                fontSize: 200,
                preview: null,
                modalita: 'testo',
                width: 480,
                height: 135,
                logoFile: null,
                confermata: false,
                stile: 'contorno',
            },
            {
                nomePosizione: 'serigrafia lato destro',
                shortName: 'destra',
                coordinate: {
                    left: 1757.5804618013356,
                    top: 304.9666699067999,
                    angle: 324.7517009435867
                },
                testo: 'DX',
                fontFamily: 'Train One',
                canvasEl: null,
                fontSize: 200,
                preview: null,
                modalita: 'testo',
                width: 480,
                height: 135,
                logoFile: null,
                confermata: false,
                stile: 'contorno',
            },
        ],
        completed: false,
        complete_message: null,
        loading: false,
        hcaptcha: {
            verified: false,
            token: null,
            ekey: null
        }
    }),

    async mounted() {
        await this.init()
        this.initCanvas()
    },
    methods: {

        displayMessage(message, error) {
            if (error) {
                window.console.log(message)
            } else {
                window.console.error(message)
            }
            this.$bvToast.toast(message, {
                title: error ? "Errore" : "Info",
                autoHideDelay: 5000,
                variant: error ? 'danger' : null,
                appendToast: true
            })

        },

        async caricaFont(opt) {
            if (!opt || !opt.family) return
            await this.loadFont(opt.family)
        },
        async applicaSerigrafia(id) {
            if (!this.serigrafie[id] || !this.serigrafie[id].fontFamily) return
            await this.loadFont(this.serigrafie[id].fontFamily.family)
            await this.setText(id)
        },
        async applicaSerigrafiaLogo(id) {

            let serigrafia = this.serigrafie[id]
            if (!serigrafia) return
            if (!serigrafia.logoFile) {
                this.displayMessage("nessun file selezionato", true)
                return
            }

            if (serigrafia.textbox) {
                this.canvas.remove(serigrafia.textbox)
            }
            serigrafia.preview = await this.creaImagePreview(serigrafia)
        },
        fetchFonts: () => fetch('https://www.googleapis.com/webfonts/v1/webfonts?key=AIzaSyCDC8Zb1UcE0sv9bz4xiA5PyaNG8xo0ERo').then(resp => resp.json()),
        async loadFont(fontName) {
            await this.$loadScript("https://ajax.googleapis.com/ajax/libs/webfont/1/webfont.js")
            return new Promise((resolve) => {
                window.WebFont.load({
                    active: resolve,
                    google: {
                        families: [fontName]
                    }
                })
            })
        },
        initCanvas() {
            fabric.Object.prototype.objectCaching = true;
            let el = document.getElementById('canvas')
            this.canvas = new fabric.Canvas(el, {
                isDrawingMode: false,
                defaultCursor: creativeMode ? undefined : 'cursor',
                hoverCursor: creativeMode ? undefined : 'cursor',
                interactive: creativeMode,
                selection: creativeMode,
            });
            const imgUrl = 'manubrio.jpg?v=' + (parseInt(Math.random() * 1000))
            fabric.Image.fromURL(imgUrl, (oImg) => {
                oImg.selectable = false;
                const orginHeight = oImg.height
                const originWidth = oImg.width

                this.canvas.setDimensions({
                    width: originWidth,
                    height: orginHeight,
                }, {backstoreOnly: true})

                const height = this._scale(orginHeight)
                const width = this._scale(originWidth)
                oImg.scaleToHeight(height);
                oImg.scaleToWidth(width);
                this.canvas.add(oImg);

                this.canvas.setDimensions({
                    width: width,
                    height: height,
                })

            });

            const logEvent = event => {
                window.console.log(`angle: ${event.target.angle}\ntop: ${event.target.top}\nleft: ${event.target.left}`)
                window.console.log(`width: ${event.target.width}\nheight: ${event.target.height}`)
                window.console.log(`cacheHeight: ${event.target.cacheHeight}\ncacheWidth:${event.target.cacheWidth}`)
                window.console.log(event)
            }
            this.canvas.on({
                'touch:gesture': logEvent,
                'touch:drag': logEvent,
                'touch:orientation': logEvent,
                'touch:shake': logEvent,
                'touch:longpress': logEvent,
                'object:moving': logEvent,
                'object:scaling': logEvent,
            })
        },
        async setText(id) {

            fabric.ITextbox = fabric.util.createClass(fabric.Textbox, fabric.Observable, {
                type: "i-textbox",
                initialize: function (text, options) {
                    this.ctx = fabric.util.createCanvasElement().getContext("2d");
                    this.callSuper("initialize", text, options);
                },
                mt_w: function () {
                    this.ctx.font = `${this.fontSize}px ${this.fontFamily}`
                    return this.ctx.measureText(this.text).width;
                },
                mt_h: function () {
                    return this.fontSize
                }
            });
            fabric.ITextbox.fromObject = function (object) {
                return new fabric.ITextbox(object.text, fabric.util.object.clone(object));
            };
            fabric.ITextbox.instances = [];

            const serigrafia = this.serigrafie[id]
            serigrafia.textColor = '#FFFFFF'

            if (serigrafia.textbox) {
                this.canvas.remove(serigrafia.textbox)
            }

            if (serigrafia.stile === 'pieno') {
                serigrafia.fill = serigrafia.textColor;
                serigrafia.stroke = 'rgba(0,0,0,0)';
                serigrafia.strokeWidth = 0;
                serigrafia.overline = false;
            } else if (serigrafia.stile === 'contorno') {
                serigrafia.fill = 'rgba(0,0,0,0)';
                serigrafia.stroke = serigrafia.textColor;
                serigrafia.strokeWidth = 2;
                serigrafia.overline = true;
            } else {
                this.displayMessage("stile testo invalido", true)
            }
            const textbox = new fabric.ITextbox(serigrafia.testo, {
                left: this._scale(serigrafia.coordinate.left),
                top: this._scale(serigrafia.coordinate.top),
                angle: serigrafia.coordinate.angle,
                textAlign: 'center',
                width: this._scale(serigrafia.width),
                fixedWidth: this._scale(serigrafia.width),
                height: this._scale(serigrafia.height),
                fixedHeight: this._scale(serigrafia.height),
                fill: serigrafia.fill,
                stroke: serigrafia.stroke,
                strokeWidth: this._scale(serigrafia.strokeWidth),
                fontSize: this._scale(serigrafia.fontSize),
                fontFamily: serigrafia.fontFamily.family,
                selectable: creativeMode,
                hasControls: creativeMode,
                overline: serigrafia.overline
            });

            serigrafia.textbox = textbox
            this.canvas.add(serigrafia.textbox)
            requestAnimationFrame(() => this.canvas.requestRenderAll())
            this.canvas.on({
                "after:render": () => {
                    let changed = textbox.height !== textbox.fixedHeight || textbox.width !== textbox.fixedWidth;
                    while (textbox.mt_h() < textbox.fixedHeight) {
                        textbox.fontSize += 1
                    }
                    while (textbox.mt_h() > textbox.fixedHeight) {
                        textbox.fontSize -= 1
                    }
                    textbox.height = textbox.fixedHeight;

                    while (textbox.mt_w() > textbox.fixedWidth) {
                        textbox.fontSize -= 1
                    }
                    textbox.width = textbox.fixedWidth
                    textbox.textAlign = 'center'
                    if (changed) {
                        requestAnimationFrame(() => this.canvas.requestRenderAll())
                    }
                }
            })


            serigrafia.preview = await this.creaImagePreview(serigrafia)
        },
        creaImagePreview(serigrafia) {
            return new Promise((resolve) => {
                const canvas = document.createElement("CANVAS")
                canvas.height = 1024
                canvas.width = 2048

                if (serigrafia.modalita === 'testo') {
                    const textbox = new fabric.ITextbox(serigrafia.testo, {
                        left: 0,
                        top: 0,
                        textAlign: serigrafia.textbox.textAlign,
                        width: serigrafia.textbox.width,
                        fixedWidth: serigrafia.textbox.fixedWidth,
                        //height: serigrafia.textbox.height,
                        height: serigrafia.textbox.fontSize,
                        //fixedHeight: serigrafia.textbox.fixedHeight,
                        fixedHeight: serigrafia.textbox.fontSize,
                        fill: serigrafia.textbox.fill,
                        stroke: serigrafia.textbox.stroke,
                        strokeWidth: serigrafia.textbox.strokeWidth,
                        fontSize: serigrafia.textbox.fontSize,
                        fontFamily: serigrafia.textbox.fontFamily,
                        selectable: creativeMode,
                        hasControls: creativeMode,
                        overline: serigrafia.textbox.overline
                    });
                    textbox.width = textbox.mt_w() * 1.5;
                    canvas.height = textbox.height * 1.3
                    canvas.width = textbox.width;
                    const fcanvas = new fabric.Canvas(canvas)
                    fcanvas.add(textbox)
                    fcanvas.requestRenderAll()

                    requestAnimationFrame(() => {
                        fcanvas.on({
                            "after:render": () => {
                                requestAnimationFrame(() => resolve(canvas.toDataURL('image/png')))
                            }
                        })
                        fcanvas.requestRenderAll()
                    })
                } else {
                    const reader = new FileReader();
                    // conversione dell'immagine in base64 url
                    reader.addEventListener("load", () => resolve(reader.result), false);
                    reader.readAsDataURL(serigrafia.logoFile);
                }
            });
        },
        async init() {
            let fonts = await this.fetchFonts()
            this.fonts = fonts.items
            fonts.items.forEach(font => {
                if (font.family === defaultFontFamily) {
                    this.serigrafie.forEach(serigrafia => {
                        serigrafia.fontFamily = font
                        this.caricaFont(font)
                    })
                }
            })
        },
        _scale(dim) {
            return dim * scale
        },

        /* hcaptcha */
        async hcaptchaOnVerify(token, ekey) {
            this.hcaptcha.verified = true
            this.hcaptcha.token = token
            this.hcaptcha.ekey = ekey

            await this.invioDati()
        },
        hcaptchaOnExpire() {
            this.hcaptcha.verified = false;
            this.hcaptcha.token = null;
            this.hcaptcha.ekey = null;
        },
        hcaptchaOnError(err) {
            this.hcaptcha.verified = false;
            this.hcaptcha.token = null;
            this.hcaptcha.ekey = null;
            this.displayMessage(err, true)
        },

        /* form */

        onSubmit(ev) {
            ev.preventDefault()
            this.$refs.submitHcaptcha.execute()
            // ^ invio form eseguito in hcaptchaOnVerify() ^
            // v richiamando la funzione invioDati() v
        },
        async invioDati() {
            if (!this.hcaptcha.verified) {
                this.displayMessage("perfavore, completa il captcha per inviare la richiesta", true)
                return
            }
            this.loading = true;
            try {
                const body = {
                    'info': this.form,
                    'serigrafie': this.serigrafie,
                    'hCaptchaResponse': this.hcaptcha.token
                }
                const response = await fetch('./m.php', {
                    method: 'POST',
                    mode: 'no-cors', // no-cors, *cors, same-origin
                    cache: 'no-cache',
                    credentials: 'same-origin', // include, *same-origin, omit
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    redirect: 'follow', // manual, *follow, error
                    referrerPolicy: 'no-referrer', // no-referrer, *no-referrer-when-downgrade, origin, origin-when-cross-origin, same-origin, strict-origin, strict-origin-when-cross-origin, unsafe-url
                    body: JSON.stringify(body) // body data type must match "Content-Type" header
                });
                let json_response = await response.json();
                this.displayMessage(json_response.message, !json_response.success)
                window.console.log("response", json_response)
                this.completed = json_response.success
                this.complete_message = json_response.message
                window.scrollTo(0, 0);
                await this.$bvModal.msgBoxOk(json_response.message, {
                    title: 'Invio richiesta',
                    size: 'sm',
                    buttonSize: 'sm',
                    okVariant: 'primary',
                    centered: true
                })
            } finally {
                this.loading = false
            }
        },
        onReset() {
            window.console.log("form reset")
            // TODO
        },
    },
};
</script>
<style lang="scss">
.canvas-container {
    margin-left: auto !important;
    margin-right: auto !important;
}

.wf-loading {
    visibility: hidden;
}

#canvas {
    width: 1450px;
    height: 359px;
    position: fixed;
    left: 0;
    top: 0;
    z-index: -1;
}

.img-preview {
    background-color: #232220;
}
</style>

